/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m22.0791 12-5.6247 7.0309c-.2588.3234-.2068.796.1166 1.0548a.7501.7501 0 0 0 1.0542-.1171L24 12l-6.3748-7.9685a.75.75 0 0 0-1.1713.937c.0001.0003-.0002-.0001 0 0M6.3744 4.032c-.0001.0002.0002-.0002 0 0L0 12l6.3744 7.968c.0001.0002-.0002-.0002 0 0a.75.75 0 1 0 1.1718-.9365m0 0L1.9208 12l5.6248-7.031c.2588-.3234.2067-.7959-.1167-1.0546-.3235-.2588-.7958-.2059-1.0546.1176M9.75 13.5h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5Zm0-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
    clipRule="evenodd"
  />,
  'CodeModule'
);
